import ContainerFactory from './container_factory'
export default ContainerFactory
